import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { 
  FileText, Download, CheckCircle2, Clock, Eye,
  AlertTriangle, Cpu, Shield, ChevronDown, ChevronRight,
  ExternalLink
} from "lucide-react";

export default function DeliverablesHubTab({ employees }) {
  const [expandedSection, setExpandedSection] = useState('tracker');

  // Show empty state if no employees data
  if (!employees || employees.length === 0) {
    return (
      <main className="max-w-[1600px] mx-auto px-6 py-6">
        <Card>
          <CardContent className="py-16 text-center">
            <FileText className="w-16 h-16 mx-auto text-muted-foreground/30 mb-4" />
            <h3 className="text-lg font-medium text-muted-foreground mb-2">No Deliverables Available</h3>
            <p className="text-sm text-muted-foreground">
              Deliverables and reports will appear here once employee assessments are completed.
            </p>
          </CardContent>
        </Card>
      </main>
    );
  }

  return (
    <main className="max-w-[1600px] mx-auto px-6 py-6">
      <Card>
        <CardContent className="py-8 text-center">
          <FileText className="w-12 h-12 mx-auto text-muted-foreground/50 mb-4" />
          <h3 className="text-lg font-medium text-muted-foreground mb-2">Deliverables Hub</h3>
          <p className="text-sm text-muted-foreground">
            Assessment reports and deliverables will be generated as employees complete their assessments.
          </p>
        </CardContent>
      </Card>
    </main>
  );
}
